import React, {
  useEffect,
  useRef,
  useCallback,
  useMemo,
  useState,
  memo
} from 'react';
import { useSelector } from 'react-redux';
import * as events from 'devextreme/events';
import TreeView from 'devextreme-react/tree-view';
import { useThemes, useTranslation } from '@core/hooks';
import { XNavigation } from '@core/utils';
import TreeViewItem from './TreeViewItem/TreeViewItem';

const SideNavigationMenu = ({
  children,
  selectedItemChanged,
  openMenu,
  compactMode,
  onMenuReady,
  treeViewRef,
  navItems
}) => {
  const [custom, setCustom] = useState(false);

  const userRole = useSelector((state) => state.user.data.role);

  const { t } = useTranslation();

  const { isDark } = useThemes();

  const items = useMemo(
    () => XNavigation.selectAllowedNavItems(userRole, navItems, t).filter((navItem: any) => navItem.text),
    [userRole]
  );

  const [menuContainerHeight, setMenuConatinerHeight] = useState(0);

  const wrapperRef = useRef();
  const menuContainerRef = useRef(null);

  const onContentReady = useCallback(
    (e) => {
      if (!custom) {
        // force TreeView rerender to ensure text display
        setCustom(true);
      }

      onMenuReady(e);
    },
    [onMenuReady, custom]
  );

  const getWrapperRef = useCallback(
    (element) => {
      const prevElement = wrapperRef.current;
      if (prevElement) {
        events.off(prevElement, 'dxclick');
      }

      wrapperRef.current = element;
      events.on(element, 'dxclick', (e) => {
        openMenu(e);
      });
    },
    [openMenu]
  );

  useEffect(() => {
    const { clientHeight } = menuContainerRef.current;

    setMenuConatinerHeight(clientHeight);
  }, []);

  const determineTreeViewItems = () => {
    if (!compactMode) {
      return items;
    }

    if (treeViewRef.current) {
      treeViewRef.current.instance.option('searchValue', '');
    }

    return [
      {
        icon: 'chevronright'
      }
    ];
  };

  const handleItemClick = (e) => {
    e.event.preventDefault();
    selectedItemChanged(e);
  };

  return (
    <div
      className={`dx-swatch-additional side-navigation-menu ${
        isDark
          ? 'side-navigation-menu--dark border-right-light'
          : 'border-right-dark'
      } ${compactMode ? 'side-navigation-menu--compact' : ''}`}
      ref={getWrapperRef}
    >
      {children}
      <div className="menu-container" ref={menuContainerRef}>
        <TreeView
          dataStructure="tree"
          height={menuContainerHeight}
          activeStateEnabled
          ref={treeViewRef}
          animationEnabled={false}
          items={determineTreeViewItems()}
          itemComponent={compactMode ? undefined : TreeViewItem}
          onItemClick={handleItemClick}
          noDataText={t('BrakUprawnien')}
          keyExpr="path"
          selectionMode="single"
          expandEvent="click"
          onContentReady={onContentReady}
          width="100%"
          searchMode="contains"
          searchEnabled
          searchExpr={['text', 'tags']}
          selectedExpr="Active"
        />
      </div>
    </div>
  );
};

export default memo(SideNavigationMenu);
